export const moduleConfig = {
    titles: {
        singular: 'Provider Mapping',
        plural: 'Provider Mappings'
    },
    routes: {
        index: '/provider-mappings',
        create: '/provider-mappings/create',
        edit: '/provider-mappings/edit',
        detail: '/provider-mappings/detail'
    }
};